export default __webpack_public_path__ + "static/zoriana-chyzhovska-7f2a65781e4b43570b925f2ea1387c28.png";